import React, {useState, useEffect} from "react";
import axios from 'axios';
import {Row, Col} from "react-bootstrap";
import {useHistory} from "react-router-dom";
import HeaderInfluxs from "./headerInfluxs";

function ListOfContra() {
    const uri = "https://bo.influxs.live/StraKingAPI00X/api/contract_list";
    const [contra, setContra] = useState(null);
    const [currentContra, setCurrentContra] = useState(null);
    const [contraLabel, setContraLabel] = useState('');
    let history=useHistory();


    const filter = (e) => {
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = contra.filter((con) => {
                return con.label.toLowerCase().startsWith(keyword.toLowerCase());
            });
            console.log('all contr'+contra);
            setContra(results);
            console.log('filter'+results);
        } else {
            setContra(currentContra);
        }

        setContraLabel(keyword);
    };
    useEffect(() => {
        const token = localStorage.getItem('token');
        console.log("token: " + token);
        const api = axios.create({
            baseURL: uri,
            headers: {'Authorization': 'Bearer ' + token}
        });
        getData();

        // we will use async/await to fetch this data
        async function getData() {
            api.get(uri).then(
                res => {
                    console.log(res);
                    setContra(res.data);
                    setCurrentContra(res.data);
                }
            ).catch(err => {

                alert(err.response.data.message);
            })

        }
    }, []);

    return (
        <div className="contra-list">
            <HeaderInfluxs/>
            <div className="list-of-contra-header">
                <Row>
                    <Col><h2>Liste des contrats</h2></Col>
                    <Col md={2}>
                        <div className="form-inner">
                            <div className="form-group">
                                <input type="search"
                                       value={contraLabel}
                                       onChange={filter}
                                       className="input"
                                       placeholder="Recherche"/>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {contra && contra.length > 0 ?  (
                <div className="contra">
                    {contra.map((contr, index) => (
                        <div key={index} onClick={() => {
                            localStorage.setItem('contraId',contr.id);
                            history.push('/contraDetails');
                             }}>
                            <div className="UserInfo">
                                <li className="list-of-contra">
                                <span><img className="Avatar"
                                           src={contr.logo}
                                           alt="logo"/></span>
                                    <span>{contr.label}</span>
                                </li>
                            </div>
                        </div>

                    ))}

                </div>
            ) : <h1>Pas de contrat</h1>}
        </div>
    )
}

export default ListOfContra;